(function() { window.GUID_a9854982_cdee_4b36_93d8_4c79b136c2ef = { getGuid: function() { return "a9854982-cdee-4b36-93d8-4c79b136c2ef"; } }; })();
var CS;
(function (CS) {
    var Helper;
    (function (Helper) {
        const renderinghelperparams = "renderinghelperparams";
        let RenderingHelper;
        (function (RenderingHelper) {
            ///Cette methode s'assure que l'element a fini de ce renderer basé sur la taille qui se stabilise
            function IsRendered(element, callback) {
                if (element == null || element.length == 0) {
                    return;
                }
                let params = element.data(renderinghelperparams);
                if (params == null) {
                    params = {
                        Timer: 0,
                        Attempt: 0,
                        LastHeight: -1
                    };
                }
                params.Attempt += 1;
                if (params.Attempt > 500) {
                    return;
                }
                clearTimeout(params.Timer);
                params.Timer = window.setTimeout(function () {
                    let newHeight = element[0].clientHeight;
                    if (newHeight > 0 && params.LastHeight == newHeight) {
                        element.data(renderinghelperparams, null);
                        callback.call(this);
                        return;
                    }
                    params.LastHeight = newHeight;
                    element.data(renderinghelperparams, params);
                    IsRendered(element, callback);
                }, 50);
            }
            RenderingHelper.IsRendered = IsRendered;
        })(RenderingHelper = Helper.RenderingHelper || (Helper.RenderingHelper = {}));
    })(Helper = CS.Helper || (CS.Helper = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-rendering-helper.js.map
